const getProductId = state => state.product.id;
export default getProductId;



// WEBPACK FOOTER //
// ./app/selectors/product.js